export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading text-center mb-3">
          商务合作与投稿
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          欢迎优质内容方、品牌方与我们联系
        </p>
        <div className="bg-background-50 rounded-2xl p-8 md:p-10 border border-background-200/70">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="text-center">
              <div className="w-14 h-14 mx-auto mb-3 rounded-2xl bg-primary-100 flex items-center justify-center">
                <i className="ri-mail-line text-primary-600 text-xl"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">商务邮箱</h3>
              <p className="text-sm text-foreground-600">business@baiyunvideo.com</p>
            </div>
            <div className="text-center">
              <div className="w-14 h-14 mx-auto mb-3 rounded-2xl bg-accent-100 flex items-center justify-center">
                <i className="ri-send-plane-line text-accent-600 text-xl"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">内容投稿</h3>
              <p className="text-sm text-foreground-600">content@baiyunvideo.com</p>
            </div>
            <div className="text-center">
              <div className="w-14 h-14 mx-auto mb-3 rounded-2xl bg-secondary-100 flex items-center justify-center">
                <i className="ri-customer-service-2-line text-secondary-600 text-xl"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">用户反馈</h3>
              <p className="text-sm text-foreground-600">feedback@baiyunvideo.com</p>
            </div>
          </div>
          <p className="text-xs text-foreground-500 text-center mt-6">
            我们会在收到邮件后1-2个工作日内回复，期待与您的合作
          </p>
        </div>
      </div>
    </section>
  );
}